import React, { useState } from 'react';
import { CheckCircle2, Lock, CreditCard, Download, ShieldCheck, Package, Star, Rocket, Crown } from 'lucide-react';
export function OrderBump() {
  const [selected, setSelected] = useState(1);
  const options = [{
    id: 0,
    color: 'border-yellow-500',
    dotColor: 'bg-yellow-500',
    badgeColor: 'bg-yellow-500 text-slate-900',
    icon: <Package className="w-4 h-4" data-id="element-108" />,
    name: 'MEGA KIT DOCENTE BASE',
    subtitle: '6 tomos + 5 bonos',
    description: 'Un año de clases de matemática: primaria y secundaria con contenido listo para usar en cada tema',
    price: '19.990',
    badge: null,
    url: 'https://laplumavirtual.com/cart/48270006223073:1'
  }, {
    id: 1,
    color: 'border-green-500',
    dotColor: 'bg-green-500',
    badgeColor: 'bg-green-500 text-white',
    icon: <Star className="w-4 h-4" data-id="element-109" />,
    name: 'MEGA KIT + EVALUACIONES LISTAS',
    subtitle: '6 tomos + Evaluaciones listas + 5 bonos',
    description: 'Todo el Kit Base + evaluaciones listas para usar, con respuestas incluidas + repaso por contenido',
    price: '22.990',
    badge: 'MÁS ELEGIDO',
    url: 'https://laplumavirtual.com/cart/48270007730401:1'
  }, {
    id: 2,
    color: 'border-blue-500',
    dotColor: 'bg-blue-500',
    badgeColor: 'bg-blue-500 text-white',
    icon: <Rocket className="w-4 h-4" data-id="element-110" />,
    name: 'MEGA KIT + CLASES ORGANIZADAS',
    subtitle: '6 tomos + Clases organizadas + 5 bonos',
    description: 'Todo el Kit Base + clases organizadas y listas para enseñar, con una estructura clara para resolver semanas completas',
    price: '24.990',
    badge: null,
    url: 'https://laplumavirtual.com/cart/48270007861473:1'
  }, {
    id: 3,
    color: 'border-[#8B5CF6]',
    dotColor: 'bg-[#8B5CF6]',
    badgeColor: 'bg-[#8B5CF6] text-white',
    icon: <Crown className="w-4 h-4" data-id="element-111" />,
    name: 'MEGA KIT COMPLETO',
    subtitle: '6 tomos + Evaluaciones listas + Clases organizadas + 5 bonos',
    description: 'El Mega Kit Docente Base + Evaluaciones listas + Clases organizadas. Todo lo que necesitás para organizar, enseñar y evaluar durante todo el año en un solo pack',
    price: '29.990',
    badge: 'TODO INCLUIDO',
    url: 'https://laplumavirtual.com/cart/48270008058081:1'
  }];
  return <section id="order-bump" className="bg-[#0f0f1a] scroll-mt-0" data-id="element-112">
      {/* Selection area */}
      <div className="min-h-[100svh] flex flex-col px-3 pt-4 pb-2" data-id="element-113">
        {/* Title - centered with equal space */}
        <div className="text-center shrink-0 mb-3" data-id="element-114">
          <h2 className="text-[34px] font-black leading-none" data-id="element-115">
            <span className="text-white" data-id="element-116">ELEGÍ TU </span>
            <span className="text-[#8B5CF6]" data-id="element-117">MEGA KIT:</span>
          </h2>
          <p className="text-gray-400 text-[11px] mt-1.5" data-id="element-118">
            Todas las opciones incluyen los 5 bonos para docentes
          </p>
        </div>

        {/* Options */}
        <div className="space-y-1.5 flex-1 flex flex-col justify-center" data-id="element-119">
          {options.map(option => <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl border p-3.5 transition-all relative ${selected === option.id ? `${option.color} bg-white/[0.07]` : 'border-white/10 bg-white/[0.03]'}`} data-id="element-120">
              {option.badge && <span className={`absolute -top-2.5 left-3 text-[10px] font-bold uppercase tracking-wider px-2.5 py-0.5 rounded-full ${option.badgeColor}`} data-id="element-121">
                  {option.badge}
                </span>}

              <div className="flex items-start gap-3" data-id="element-122">
                {/* Radio */}
                <div className={`w-6 h-6 rounded-full border-2 shrink-0 mt-0.5 flex items-center justify-center ${selected === option.id ? option.color : 'border-gray-600'}`} data-id="element-123">
                  {selected === option.id && <div className={`w-3.5 h-3.5 rounded-full ${option.dotColor}`} data-id="element-124" />}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-125">
                  <div className="flex items-start justify-between gap-2" data-id="element-126">
                    <div className="min-w-0 flex items-center gap-1.5" data-id="element-127">
                      <span className={`shrink-0 ${selected === option.id ? 'text-white' : 'text-gray-500'}`} data-id="element-128">
                        {option.icon}
                      </span>
                      <p className="font-bold text-white text-[15px] leading-tight" data-id="element-129">
                        {option.name}
                      </p>
                    </div>
                    <span className="text-white font-black text-2xl leading-none shrink-0" data-id="element-130">
                      ${option.price}
                    </span>
                  </div>
                  <p className="text-gray-500 text-[11px] mt-0.5 ml-6" data-id="element-131">
                    {option.subtitle}
                  </p>
                  <p className="text-gray-400 text-[11px] leading-snug mt-0.5 ml-6" data-id="element-132">
                    {option.description}
                  </p>
                </div>
              </div>
            </button>)}
        </div>

        {/* CTA + Payment */}
        <div className="shrink-0 mt-1 space-y-1" data-id="element-133">
          <a href={options[selected].url} target="_blank" rel="noopener noreferrer" className="w-full bg-green-500 hover:bg-green-400 text-white font-black text-lg rounded-xl flex items-center justify-center gap-2 transition active:scale-95 shadow-[0_0_24px_rgba(34,197,94,0.35)] uppercase tracking-wide" style={{
          paddingTop: '18px',
          paddingBottom: '18px'
        }} data-id="element-134">
            SÍ, QUIERO EL MEGA KIT COMPLETO →
          </a>
          <p className="text-gray-500 text-[11px] text-center flex items-center justify-center gap-1.5" data-id="element-135">
            <CreditCard className="w-3.5 h-3.5" data-id="element-136" />
            Podés pagar con tarjeta, transferencia o Mercado Pago.
          </p>
        </div>
      </div>

      {/* Content section below */}
      <div className="px-4 pb-10 pt-6 border-t border-white/10 bg-[#111125]" data-id="element-137">
        <h3 className="text-lg font-black text-white mb-3 text-center uppercase" data-id="element-138">
          MEGA KIT COMPLETO INCLUYE:
        </h3>

        <p className="text-gray-300 text-sm text-center mb-5" data-id="element-139">
          Incluye 6 tomos completos organizados para todo el año:
        </p>

        {/* Primaria */}
        <p className="text-[#8B5CF6] font-bold text-sm mb-2 uppercase" data-id="element-140">
          📚 Primaria
        </p>
        <div className="space-y-1.5 mb-2" data-id="element-141">
          {['Tomo 1 – Operaciones básicas y cálculo', 'Tomo 2 – Problemas y comprensión matemática', 'Tomo 3 – Fracciones, decimales y medidas'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-142">
              <CheckCircle2 className="w-4 h-4 text-[#8B5CF6] shrink-0 mt-0.5" data-id="element-143" />
              <span className="text-gray-300 text-xs" data-id="element-144">{item}</span>
            </div>)}
        </div>
        <div className="space-y-1.5 mb-5" data-id="element-145">
          {['Contenidos básicos organizados por tema', 'Actividades listas para usar en clase', 'Ejercicios progresivos para cada nivel', 'Material claro y fácil de aplicar'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-146">
              <CheckCircle2 className="w-4 h-4 text-green-400 shrink-0 mt-0.5" data-id="element-147" />
              <span className="text-gray-300 text-xs" data-id="element-148">{item}</span>
            </div>)}
        </div>

        {/* Secundaria */}
        <p className="text-[#8B5CF6] font-bold text-sm mb-2 uppercase" data-id="element-149">
          📚 Secundaria
        </p>
        <div className="space-y-1.5 mb-2" data-id="element-150">
          {['Tomo 4 – Álgebra práctica', 'Tomo 5 – Funciones y gráficos', 'Tomo 6 – Problemas, repaso y evaluación'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-151">
              <CheckCircle2 className="w-4 h-4 text-[#8B5CF6] shrink-0 mt-0.5" data-id="element-152" />
              <span className="text-gray-300 text-xs" data-id="element-153">{item}</span>
            </div>)}
        </div>
        <div className="space-y-1.5 mb-5" data-id="element-154">
          {['Álgebra y resolución de problemas paso a paso', 'Ejercicios aplicados para cada contenido', 'Ejemplos resueltos para facilitar la comprensión', 'Material listo para usar en clase sin adaptar'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-155">
              <CheckCircle2 className="w-4 h-4 text-green-400 shrink-0 mt-0.5" data-id="element-156" />
              <span className="text-gray-300 text-xs" data-id="element-157">{item}</span>
            </div>)}
        </div>

        {/* Evaluaciones + Clases organizadas */}
        <div className="space-y-3 mb-6" data-id="element-158">
          <div className="bg-green-500/10 border border-green-500/20 rounded-lg p-3" data-id="element-159">
            <p className="text-green-400 font-bold text-xs mb-1" data-id="element-160">
              🟢 Evaluaciones listas
            </p>
            <p className="text-gray-400 text-[11px] leading-snug" data-id="element-161">
              Exámenes por tema + respuestas incluidas + repaso por contenido
            </p>
          </div>
          <div className="bg-[#8B5CF6]/10 border border-[#8B5CF6]/20 rounded-lg p-3" data-id="element-162">
            <p className="text-[#8B5CF6] font-bold text-xs mb-1" data-id="element-163">
              🟣 Clases organizadas
            </p>
            <p className="text-gray-400 text-[11px] leading-snug" data-id="element-164">
              Estructura por tema + secuencia clara + clases listas para enseñar
            </p>
          </div>
        </div>

        {/* Bonos */}
        <div className="mb-6" data-id="element-165">
          <p className="text-yellow-400 font-bold text-sm mb-3" data-id="element-166">
            + 5 BONOS INCLUIDOS:
          </p>
          <div className="space-y-2" data-id="element-167">
            {['Pack imprimible: clases listas en 1 minuto', 'Sistema de organización docente sin estrés', 'Kit de actividades express para el aula', 'Kit visual para explicar matemática fácil', 'Sistema de refuerzo y repaso inteligente'].map((bonus, i) => <div key={i} className="flex items-start gap-2" data-id="element-168">
                <CheckCircle2 className="w-4 h-4 text-yellow-400 shrink-0 mt-0.5" data-id="element-169" />
                <span className="text-gray-300 text-xs" data-id="element-170">{bonus}</span>
              </div>)}
          </div>
        </div>

        {/* Final block */}
        <div className="bg-white/5 border border-white/10 rounded-xl p-4" data-id="element-171">
          <div className="grid grid-cols-2 gap-3" data-id="element-172">
            {[{
            icon: <Lock className="w-4 h-4" data-id="element-173" />,
            text: 'Pago único'
          }, {
            icon: <Download className="w-4 h-4" data-id="element-174" />,
            text: 'Acceso inmediato'
          }, {
            icon: <Download className="w-4 h-4" data-id="element-175" />,
            text: 'Descarga ilimitada'
          }, {
            icon: <ShieldCheck className="w-4 h-4" data-id="element-176" />,
            text: 'Sin suscripciones'
          }].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-177">
                <span className="text-green-400" data-id="element-178">{item.icon}</span>
                <span className="text-gray-300 text-xs font-medium" data-id="element-179">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}